<template>
  <div class="betslip-tax-info-wrapper">
    <div class="possible-winning"
         v-if="betslipConfig.winnings">
      <div class="label important">
        Possible winn
      </div>
      <div class="value important">
        {{meta.possibleWinning}}
      </div>
    </div>
    <div class="taxes"
         v-if="!taxDisabled">
      <div class="tax">
        <div class="tax-label">
          <span>
            {{'general_payin_tax' | translate}} {{`(${payinTax.policy.taxValue}%)`}}
          </span>
        </div>
        <div class="tax-value">
          <span>
            {{payinTax.taxAmountRounded}}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'BetslipTaxInfo',
  props: {
    taxDisabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters([
      'meta',
      'ticket',
      'betslipConfig',
    ]),
    payinTax() {
      return this.meta.payinTax;
    },
  },
};
</script>

<style lang="scss" scoped>
  .betslip-tax-info-wrapper {
    margin-bottom: 8px;
    float: left;
    width: 100%;

    .possible-winning {
      font-size: 14px;
      float: left;
      width: 100%;
      margin-bottom: 4px;
      font-weight: 700;

      .label {
        float: left;
      }

      .value {
        float: right;
      }
    }

    .important {
      color: #ffc107;
    }

    .taxes {
      float: left;
      width: 100%;
      font-size: 12px;
      font-weight: 300;
      color: #acacad;
      text-transform: uppercase;

      .tax {
        float: left;
        width: 100%;
        margin-bottom: 4px;
      }

      .tax-label {
        float: left;
      }

      .tax-value {
        float: right;
      }
    }
  }
</style>
